export default "__VITE_ASSET__BG38cuGk__"